import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LegalAcceptanceModal from "../Legal/LegalAcceptanceModal";
import NotificationDrawer from "../Notification/NotificationDrawer";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();
  const [collapsed, setCollapsed] = useState(false);

  // If no user is logged in, don't render sidebar
  const showSidebar = location.pathname !== "/login";

  return (
    <div className="min-h-screen flex">
      {/* Global Legal Policy Acceptance prompt for authenticated users */}
      {user && <LegalAcceptanceModal />}
      {user && <NotificationDrawer />}

      {showSidebar && user && (
        <Sidebar
          userRole={user.role}
          collapsed={collapsed}
          onToggle={() => setCollapsed((c) => !c)}
        />
      )}

      <main
        className={`flex-1 bg-[#F8FAFA] p-4 sm:p-5 md:p-6 mt-16 md:mt-0 transition-[margin] duration-200 ${
          collapsed ? "md:ml-[68px]" : "md:ml-60"
        }`}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;